import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Factory, Response } from 'app/app.factory';
import { Navigation } from 'app/core/navigation/navigation.types';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';
import { APP_VERSION } from 'version';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private $version: BehaviorSubject<string> = new BehaviorSubject<string>(APP_VERSION);
    private _httpClient = inject(HttpClient);
    private _factory = inject(Factory);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    /**
     * Getter version of package.json
     */

    get version$(): Observable<string> {
        return this.$version.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Response<Navigation>>(`${this._factory.url}/menu`).pipe(
            this._factory.wrap<Navigation>(),
            tap((navigation) => {
                // Fix navigation items
                if (navigation) {
                    this._fixNavigation(navigation.default);
                    this._fixNavigation(navigation.compact);
                    this._fixNavigation(navigation.futuristic);
                    this._fixNavigation(navigation.horizontal);
                }
                this._navigation.next(navigation);
            })
        );
    }

    private _fixNavigation(items: any[]): void {
        if (!items) return;
        for (const item of items) {
            // Fix for 'Configuración' (Settings) item
            // Change link from '/client' to '/client/settings' so it matches specific route
            if (item.link === '/client') {
                item.link = '/client/settings';
                item.exactMatch = true;
            }

            if (item.children) {
                this._fixNavigation(item.children);
            }
        }
    }
}
